module.exports = __webpack_public_path__ + "static/media/swiss-life.b760af55.svg";